const urls = {
  AUTH_TOKEN_PAIR: () => "/api/token/pair",
  AUTH_TOKEN_REFRESH: () => "/api/token/refresh",
  ACCOUNT: () => "/api/users/me",
  QUOTES: () => "/api/quotes/all",
  INGREDIENTS: () => "/api/ingredients/all",
};

export default urls;
